import Seo from "@/components/seo/Seo";
import Reveal from "@/components/ui-primitives/Reveal";
import Breadcrumbs from "@/components/layout/Breadcrumbs";
import { Link } from "react-router-dom";
import { executive, CANONICAL_ORIGIN } from "@/data/site";

export default function Speaking() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    url: `${CANONICAL_ORIGIN}/leadership/speaking`,
    name: "Speaking Engagements — Adeshi Moffi",
    about: { "@id": `${CANONICAL_ORIGIN}/leadership#adeshi-moffi` },
    hasPart: executive.speakingTopics.map((t) => ({
      "@type": "CreativeWork",
      name: t,
      author: { "@id": `${CANONICAL_ORIGIN}/leadership#adeshi-moffi` },
    })),
  };

  return (
    <>
      <Seo
        title="Speaking Engagements — Adeshi Moffi | Investors Pathway"
        description="Speaking topics and engagements by Adeshi Moffi, President of Investors Pathway LLC — private equity, capital raising, consumer brands, retail, manufacturing, and family office investing."
        path="/leadership/speaking"
        image={executive.headshot}
        jsonLd={jsonLd}
      />

      <section className="pt-28 md:pt-36 pb-16">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
          <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Leadership", to: "/leadership" }, { label: "Speaking" }]} />
          <Reveal>
            <div className="mt-10 section-num">06 / Speaking</div>
            <h1 data-testid="speaking-title" className="h-display text-[3rem] md:text-[4.6rem] text-[#0A1128] mt-6 max-w-4xl">
              Selected speaking topics.
            </h1>
            <p className="mt-6 body-lead max-w-3xl">
              Available for keynotes, panels, and closed-door institutional briefings.
              Please contact the Office of the President for availability and rates.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
          <ul className="border-t border-[#E2E8F0]" data-testid="speaking-topics">
            {executive.speakingTopics.map((t, i) => (
              <Reveal
                as="li"
                key={t}
                className="border-b border-[#E2E8F0] py-8 md:py-10 grid grid-cols-12 gap-6 items-center hover:bg-[#F5F3EE] transition-colors duration-300 px-2"
              >
                <div className="col-span-2 md:col-span-1">
                  <span className="section-num text-[#8E7331]">{String(i + 1).padStart(2, "0")}</span>
                </div>
                <div className="col-span-10 md:col-span-9">
                  <h2 className="h-editorial text-2xl md:text-3xl text-[#0A1128] leading-tight">{t}</h2>
                </div>
                <div className="col-span-12 md:col-span-2 md:text-right">
                  <Link
                    to="/leadership/contact"
                    data-testid={`speaking-inquire-${i}`}
                    className="link-underline text-xs uppercase tracking-[0.2em] font-sans"
                  >
                    Inquire
                  </Link>
                </div>
              </Reveal>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
}
